import React, { useState, useEffect } from "react";
import { object, func, string, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";

import Icon from "../../icons";
import FullScreenIcon from "../../../../assets/icons/full-screen-icon.png";

import "./lightBox.m.css";

const LightBox = ({ element, closePopup, imageCDN, isbutton = true, isCarousel = false }) => {
  const [showCaption, setShowCaption] = useState(true);
  const [showCaptionOnHover, setShowCaptionOnHover] = useState(false);
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    global.deviceWidth > 876 && setIsMobile(false);
  }, []);

  const closeCaptionInDesktop = () => {
    !isMobile && setShowCaption(false);
  };

  const closeCaptionInMobile = () => {
    isMobile && setShowCaption(!showCaption);
  };

  const mouseIn = () => {
    !isMobile && !showCaption && setShowCaptionOnHover(true);
  };

  const mouseOut = () => {
    !isMobile && showCaptionOnHover && setShowCaptionOnHover(false);
  };

  const setPosition = isCarousel ? "" : "fixed-lightbox-wrapper";

  const makeFullScreen = () => {
    if (document.fullscreenElement) {
      document
        .exitFullscreen()
        .then(() => {})
        .catch((err) => console.error(err));
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  return (
    <div styleName={`lightbox-wrapper ${setPosition}`}>
      <div styleName="lightbox" className="lightbox">
        <div styleName="image-with-caption-wrapper">
          <div styleName="image-base" onMouseEnter={mouseIn} onMouseLeave={mouseOut}>
            <img
              src={`//${imageCDN}/${element["image-s3-key"]}`}
              alt={element.title || "image-s3-key"}
              styleName="image"
              onClick={closeCaptionInMobile}
            />
            {(showCaption || showCaptionOnHover) && element.title && (
              <figcaption styleName="image-caption" onClick={closeCaptionInDesktop}>
                <div styleName="caption-base">
                  {element.title}
                  {element["image-attribution"] && (
                    <span styleName="image-attribute">{element["image-attribution"]}</span>
                  )}
                </div>
              </figcaption>
            )}
          </div>
        </div>
        {!isCarousel && isbutton && (
          <>
            <img
              src={`${assetify(FullScreenIcon)}`}
              alt="full screen icon of close"
              styleName="full-screen-icon"
              onClick={makeFullScreen}
            ></img>
            <button onClick={closePopup} styleName="icon-close">
              <Icon type="close" className="close" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

LightBox.propTypes = {
  element: object,
  closePopup: func,
  imageCDN: string,
  isbutton: bool,
  isCarousel: bool,
  key: string,
};

const mapStateToProps = (state) => ({
  imageCDN: get(state, ["qt", "config", "cdn-image"], []),
});

export default connect(mapStateToProps)(LightBox);
